import { ROUTE_PATH, OperationType } from "common/constants/sm-constants";
import { WidgetModel } from "common/models/utility-models/base-model";
import { GridMetaModel, Headers } from "common/models/utility-models/meta-model";

export class FeedbackGridMetaModel extends GridMetaModel<Headers> {
    constructor() {
      super(
        'Feedback',
        ROUTE_PATH.feedbackGrid,
        ROUTE_PATH.addFeedback,
        false,
        true,
        8,
        false,
        true,
        ['title'],
        false,
        [],
        {
          isDownloadExcel: false,
          excelFileName: '',
          btnLabel: '',
          headers: [],
        },
        false,
        { evalKey: 'editDeleteActionFlag', evalParam: [1], decisiveParam: false },
        false,
        false,
        true,
        null,
        { evalKey: 'editDeleteActionFlag', evalParam: [1], decisiveParam: false }
      );
    }
  
    prepareHeaderList(): Headers[] {
      const headers: Headers[] = [];
      const title = new Headers('Title', 'title', false, true, 'text');
      const question = new Headers(
        'Question',
        'questionCount',
        false,
        true,
        'text'
      );
      const preview = new Headers('Preview', 'preview', false, true, 'text', '0',
        {
          isColumnNavigation: true,
          navigationUrl: ROUTE_PATH.feedbackPreview,
          navigateOperationType: OperationType.UPDATE,
          navigateTransferData: new WidgetModel()
        }
      );
  
      headers.push(title);
      headers.push(question);
      headers.push(preview);
      return headers;
    }
  }
  